const React = require('react');
const PropTypes = require('prop-types');

class ChannelLogo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hideLogo: true
        };
        this.handleError = this.handleError.bind(this);
    }

    componentDidMount() {
        this.setState({
            hideLogo: false
        });
    }

    handleError() {
        this.setState({
            hideLogo: true
        });
    }

    displayPlaceholder(className, alt) {
        if (this.props.usePlaceholder) {
            return (
                <p className={`${className} logo-placeholder-text u-margin-bottom-none`}>{ alt }</p>
            );
        } else {
            return null;
        }
    }

    render() {
        const { className, alt, src, placeholderClassName } = this.props;
        if (this.state.hideLogo || !src) {
            const classForPlaceholder = placeholderClassName || className;
            return this.displayPlaceholder(classForPlaceholder, alt);
        } else {
            return (
                <img src={src} key={alt} alt={alt} className={className} onError={this.handleError} />
            );
        }
    }
}

ChannelLogo.propTypes = {
    src: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
    className: PropTypes.string.isRequired,
    placeholderClassName: PropTypes.string,
    usePlaceholder: PropTypes.bool.isRequired
};

module.exports = ChannelLogo;
